"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheState = void 0;
var CacheState;
(function (CacheState) {
    CacheState[CacheState["Uncached"] = 0] = "Uncached";
    CacheState[CacheState["Caching"] = 1] = "Caching";
    CacheState[CacheState["Cached"] = 2] = "Cached";
})(CacheState = exports.CacheState || (exports.CacheState = {}));
//# sourceMappingURL=FoshChatCaching.Types.js.map